import React, { useEffect, useState } from 'react'
import { X, AlertCircle, Trash2 } from 'lucide-react'

// `confirmText`: when set, the delete button stays disabled until this exact word is typed.
const ConfirmDeleteModal = ({
  isOpen,
  onClose,
  cantiqueName,
  onConfirm,
  message,
  warning = 'Cette action est irréversible et supprimera définitivement le cantique et tous ses contenus.',
  confirmLabel = 'Supprimer',
  confirmText,
}) => {
  const [typed, setTyped] = useState('')

  useEffect(() => {
    if (isOpen) setTyped('')
  }, [isOpen])

  if (!isOpen) return null

  const locked = Boolean(confirmText) && typed.trim().toUpperCase() !== confirmText

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose()
    }
  }

  return (
    <div className="confirmDeleteModal" onClick={handleBackdropClick} role="dialog" aria-modal="true" aria-labelledby="confirmDeleteModal-title">
      <div className="confirmDeleteModal__container">
        <button className="confirmDeleteModal__close" onClick={onClose} aria-label="Fermer">
          <X size={24} />
        </button>

        <div className="confirmDeleteModal__icon">
          <AlertCircle size={48} />
        </div>

        <h2 id="confirmDeleteModal-title" className="confirmDeleteModal__title">Confirmer la suppression</h2>
        
        <p className="confirmDeleteModal__message">
          {message || <>Êtes-vous sûr de vouloir supprimer le cantique <strong>"{cantiqueName}"</strong> ?</>}
        </p>
        
        <p className="confirmDeleteModal__warning">{warning}</p>

        {confirmText && (
          <label className="confirmDeleteModal__confirm">
            <span>Tapez <strong>{confirmText}</strong> pour confirmer</span>
            <input
              type="text"
              value={typed}
              onChange={(e) => setTyped(e.target.value)}
              autoComplete="off"
              autoFocus
            />
          </label>
        )}

        <div className="confirmDeleteModal__actions">
          <button
            className="confirmDeleteModal__btn confirmDeleteModal__btn--cancel"
            onClick={onClose}
          >
            Annuler
          </button>
          <button
            className="confirmDeleteModal__btn confirmDeleteModal__btn--delete"
            disabled={locked}
            onClick={() => {
              onConfirm()
              onClose()
            }}
          >
            <Trash2 size={16} />
            <span>{confirmLabel}</span>
          </button>
        </div>
      </div>
    </div>
  )
}

export default ConfirmDeleteModal
